import { type ComponentProps } from 'react';
import { RadioGroup } from '@tackle-io/platform-ui';
import { InputLabel } from './InputLabel';
import { FormControl } from 'vendor/material';
import { HelperText } from './HelperText';
import { makeStyles } from 'vendor/material';

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: theme.spacing(0.5),
  },
}));

const RadioGroupField = ({
  errorMessage,
  dataId,
  disabled,
  helperText,
  label,
  name,
  options,
  required,
  tooltipText,
  ...inputProps
}: ComponentProps<typeof RadioGroup> & {
  errorMessage?: string;
  dataId: string;
  helperText?: string;
  label: string;
  name: string;
  required?: boolean;
  tooltipText?: string;
}) => {
  const classes = useStyles();
  return (
    <FormControl
      aria-disabled={disabled}
      disabled={disabled}
      error={!!errorMessage}
      data-id={dataId}
    >
      <InputLabel
        aria-disabled={disabled}
        className={classes.label}
        dataId={`${dataId}-label`}
        label={label}
        required={required}
        tooltipText={tooltipText}
      />
      <RadioGroup
        data-id={dataId}
        direction="horizontal"
        options={options}
        disabled={disabled}
        {...inputProps}
      />

      <HelperText error={!!errorMessage}>
        {errorMessage || helperText}
      </HelperText>
    </FormControl>
  );
};
export default RadioGroupField;
